module.exports = __webpack_public_path__ + "static/media/annualGiftSub.d9fe3feb.png";